import React from 'react'
import ChatwithTutor from '../../Components/client/chats/ChatwithTutor'
function Chatwithtutor() {
  return (
    <div>
      <ChatwithTutor/>
    </div>
  )
}

export default Chatwithtutor
